import Schema, { optional } from 'AppReact/schema';
import { assignTech, assignVendor, admin } from 'types';

const ref = {
  current: optional('string'),
};

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  label: Schema('string', 'primitive-nullable', { defaultValue: null }),
  assignedTechId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  assignedVendorId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  assignedAdminId: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  techs: Schema(assignTech, 'array', { defaultValue: [] }),
  admins: Schema(admin, 'array', { defaultValue: [] }),
  vendors: Schema(assignVendor, 'array', { defaultValue: [] }),
  searchVal: Schema('string', 'primitive', { defaultValue: '' }),
  selectedTab: Schema('string', 'primitive', { defaultValue: '' }),
  textHeader: Schema('boolean', 'primitive-nullable', { defaultValue: true }),
  hideAdmins: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hideTechs: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  hideVendors: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  containerRef: Schema(ref, 'object', { defaultValue: { current: null } }),
}